
export const actions = {
  setWorkOrders: 'SET::SITEWORKORDERS'
}

export const setSiteWorkOrders = siteWorkOrders => ({ type: actions.setWorkOrders, siteWorkOrders })

export default actions
